import { useLocation } from "react-router-dom";
import Header from "./Header";
import MenuMobile from './Mobile'
import ScrollButton from "./Scroll/useScroll";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

// Rotas que USAM o layout simples (sem Header/Footer)
const layoutConfig = {
  simpleLayoutRoutes: [
    "/painel/sign-in",
    "/painel/sign-admin",
    "/painel/dashboard",
  ],
  // Rotas que SÓ TÊM o prefixo do layout simples (incluindo rotas dinâmicas)
  simpleLayoutPrefixes: [
      "/painel/treinamentos", // Incluirá /painel/treinamentos E /painel/treinamentos/123
  ]
};

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const pathname = location.pathname;

  // 1. Verifica se é uma rota de caminho exato
  const isExactMatch = layoutConfig.simpleLayoutRoutes.includes(pathname);
  
  // 2. Verifica se é uma rota dinâmica que começa com um dos prefixos do layout simples
  const isPrefixMatch = layoutConfig.simpleLayoutPrefixes.some(prefix => 
      pathname.startsWith(prefix)
  );

  // 3. Define o layout simples se houver correspondência exata OU prefixo
  const isSimpleLayout = isExactMatch || isPrefixMatch;

  if (isSimpleLayout) {
    return <>{children}</>;
  }

  return(
    <>
      <Header/>
      <MenuMobile/>
      {children}
      <ScrollButton/>
      <Footer/>
    </>
  );
}